import { render, staticRenderFns } from "./expansion-panel.vue?vue&type=template&id=775b447c&scoped=true"
import script from "./expansion-panel.vue?vue&type=script&lang=ts"
export * from "./expansion-panel.vue?vue&type=script&lang=ts"
import style0 from "./expansion-panel.vue?vue&type=style&index=0&id=775b447c&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775b447c",
  null
  
)

export default component.exports